import { render, staticRenderFns } from "./OutOfCreditsDialog.vue?vue&type=template&id=4528937d"
import script from "./OutOfCreditsDialog.vue?vue&type=script&lang=js"
export * from "./OutOfCreditsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports